import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  ReviewMinimalFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { ReviewIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type ReviewDocumentAddedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: ReviewMinimalFragment;
};

export function isReviewDocumentAddedActivity(
  q: ActivityFragment
): q is ReviewDocumentAddedActivity {
  return q.key === "review.document_added";
}

interface ReviewDocumentAddedActivityProps {
  activity: ReviewDocumentAddedActivity;
}

export const ReviewDocumentAddedActivity: React.FC<ReviewDocumentAddedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="reviewDocumentAddedActivity"
        visual={<ReviewIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.reviewDocumentAdded", {
            review: (
              <Link to={`/reviews/${activity.trackable.id}`}>
                {t("activity.objects.review")}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
